import { createReducer, on } from '@ngrx/store';
import * as PlantsWithBOMByProductListActions from './plants-with-bom-by-product-list.actions';
import { ProductBOM, PlantsWithBOMList } from './plants-with-bom-by-product-list.actions';

export interface PlantsWithBOMByProductListState {
  cache: { [key: string]: PlantsWithBOMList[] };
  loading: { [key: string]: boolean };
  error: { [key: string]: any };
}

export const initialState: PlantsWithBOMByProductListState = {
  cache: {},
  loading: {},
  error: {},
};

function buildKey(products: ProductBOM[]): string {
  return JSON.stringify([...products].sort((a, b) => JSON.stringify(a).localeCompare(JSON.stringify(b))));
}

export const plantsWithBOMByProductListReducer = createReducer(
  initialState,
  on(PlantsWithBOMByProductListActions.loadPlantsWithBOMByProductList, (state, { products }) => {
    const key = buildKey(products);
    return {
      ...state,
      loading: { ...state.loading, [key]: true },
      error: { ...state.error, [key]: null },
    };
  }),
  on(PlantsWithBOMByProductListActions.loadPlantsWithBOMByProductListSuccess, (state, { products, result }) => {
    const key = buildKey(products);
    return {
      ...state,
      cache: { ...state.cache, [key]: result },
      loading: { ...state.loading, [key]: false },
      error: { ...state.error, [key]: null },
    };
  }),
  on(PlantsWithBOMByProductListActions.loadPlantsWithBOMByProductListFailure, (state, { products, error }) => {
    const key = buildKey(products);
    return {
      ...state,
      loading: { ...state.loading, [key]: false },
      error: { ...state.error, [key]: error },
    };
  }),
  on(PlantsWithBOMByProductListActions.resetPlantsWithBOMByProductListState, () => initialState),
);
